import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(theme => ({
  formTitleContainer: {
    padding: "1rem",
    fontWeight: "bold",
    fontSize: "17px",
    color: theme.palette.primary.main,
  },
  Title: {
    padding: "0.8rem",
    backgroundColor: theme.palette.grey[200],
    fontWeight: "bold",
  },
  userInput: {
    padding: "0.8rem",
    fontWeight: "bold",
    minHeight: "45.61px",
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
  },
  userInputCorrect: {
    padding: "0.8rem",
    fontWeight: "bold",
    minHeight: "45.61px",
    backgroundColor: "#388e3c",
    color: "white",
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
  },
  userInputIncorrect: {
    padding: "0.8rem",
    fontWeight: "bold",
    minHeight: "45.61px",
    backgroundColor: "#ff5252",
    color: "white",
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
  },
  userInputLink: {
    display: "block",
    padding: "0.8rem",
    overflowWrap: "anywhere",
  },
}));
